import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEseaComponent } from './simple-icons-esea.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEseaComponent ],
    exports:      [ SimpleIconsEseaComponent ],
    bootstrap:    []
})
export class SimpleIconsEseaModule {}
